import { ReactComponent as ReactSpinner } from './spinner.svg';

const Spinner = () => {
    return <ReactSpinner />
}

export default Spinner;